<script lang="ts" setup>
import '../scss/FormHome.scss';
import { ref, onMounted, computed } from 'vue';
import { calculatePolicyPrice } from '../../../../helpers';
import Slider from './Slider.vue';
import { useRoute, useRouter } from 'vue-router';
import {
  getAssets,
  getSubAssets,
  createAudits,
  findClient,
  calculatePriceForLanding,
  getProducts,
} from '../../../../repositories/landing.repository';
import storePolicy from '@store/policy';
import getSubDomainInitial from '../../../../helpers/getSubDomainInitial';
import getImageFlag from '../../../../helpers/getImageFlag';
import getDolarArgentina from '../../../../helpers/exchangeArgentina';
import { getDolarChile } from '../../../../helpers/exchangeChile';
import { getTypeMoney } from '../../../../helpers/getTypeMoneyByCountry';
import { useToast } from '../../../../composables/useToast';
import { useI18n } from 'vue-i18n';
import { IAsset } from '../../../../types/assets.type';

const { t } = useI18n();
const store = storePolicy();
const subDomainInitial = ref<string>('');
const router = useRouter();
const route = useRoute();
const refTableForm = ref<any>(null);
const toogleIndemnizationLimit = ref<boolean>(false);
const endPrice = ref<number>(0);
const errorResponse = ref<string | null>(null);
const indemnificationLimit = ref<number>(200000);
const dolarPrice = ref<number | null>(null);
const UFvalue = ref<number | null>(null);
const isButtonDisabled = ref<boolean>(false);
const { $toast } = useToast();
const assetOptions = ref<any>([]);

const fetchDolarArgentina = async () => {
  try {
    const cotizations = await getDolarArgentina();
    dolarPrice.value = cotizations;
    store.setProp({ key: 'pricing', value: { dolar: dolarPrice.value } });
    handleSliderChange(dolarPrice.value * 1000);
  } catch (error) {
    $toast?.error(
      t(
        'landing.components.form_home.hay_un_error_en_la_cotizacion_de_divisas',
      ),
    );
  }
};

const fetchDolarChile = async () => {
  try {
    const cotizations = await getDolarChile();
    if (!cotizations || !cotizations.dolar || !cotizations.uf) {
      $toast?.error(
        t(
          'landing.components.form_home.hay_un_error_en_la_cotizacion_de_divisas',
        ),
      );
      return;
    }

    dolarPrice.value = cotizations.dolar;
    UFvalue.value = cotizations.uf;
    store.setProp({
      key: 'pricing',
      value: { dolar: dolarPrice.value, uf: UFvalue.value },
    });

    if (!dolarPrice.value || !UFvalue.value) {
      isButtonDisabled.value = true;
    } else {
      handleSliderChange(Math.round((1000 * dolarPrice.value) / UFvalue.value));
    }
  } catch (error) {
    $toast?.error(
      t(
        'landing.components.form_home.hay_un_error_en_la_cotizacion_de_divisas',
      ),
    );
  }
};

const handleCountrySpecificLogic = async (country: string) => {
  if (country === 'ARGENTINA') {
    await fetchDolarArgentina();
  } else if (country === 'CHILE' || country === 'SPAIN') {
    await fetchDolarChile();
  } else if (country === 'MEXICO') {
    endPrice.value = 0;
    // endPrice.value = calculatePolicyPrice(200000);
  }
};

const fetchAssets = async () => {
  try {
    const assets = await getAssets();
    const fieldAsset = fields.value.find((field: any) => field.key === 'asset');
    fieldAsset.options = assets;
  } catch (error) {
    $toast?.error('Error fetching assets');
  }
};

onMounted(async () => {
  subDomainInitial.value = getSubDomainInitial();
  await handleCountrySpecificLogic(subDomainInitial.value);
  await fetchAssets();
});
// computed(() => fields.value);

const fields: any = ref([
  {
    key: 'typePolicieTransport',
    title: t('landing.components.form_home.tipo_de_poliza'),
    type: 'select',
    validations: {
      rules: {
        required: true,
      },
      messages: {
        required: t('global.es_obligatorio'),
      },
    },
    selectLabel: null,
    placeholder: t('landing.components.form_home.tipo_de_poliza_placeholder'),
    value: null,
    cols: 12,
    customClass: 'inputLanding_transporte',
    listenSelect: true,
    options: [
      { id: 1, nombre: 'Terrestre' },
      { id: 2, nombre: 'Maritimo' },
      { id: 3, nombre: 'Paqueteria' },
    ],
  },
  {
    key: 'email',
    title: t('global.email'),
    type: 'email',
    validations: {
      rules: {
        required: true,
        email: true,
      },
      messages: {
        required: t('global.es_obligatorio'),
        email: t('global.email_invalido'),
      },
    },

    placeholder: t('global.email'),
    value: null,
    cols: 12,
    customClass: 'inputLanding',
    preppendClass: 'inputLanding-custom-user bg-white',
    iconLeft: '/img/user.png',
    listenFocus: true,
  },
  {
    key: 'phone',
    title: t('global.telefono'),
    type: 'text',
    validations: {
      rules: {
        required: true,
        max: 12,
        min: 8,
      },
      messages: {
        required: t('global.es_obligatorio'),
      },
    },

    placeholder: t('global.telefono'),
    value: null,
    cols: 12,
    customClass: 'inputLanding',
    preppendClass: 'inputLanding-custom-phone bg-white',
    iconLeft: getImageFlag(window.location.origin),
  },
  {
    key: 'asset',
    title: t('landing.components.form_home.tipo_de_mercancia_transportada'),
    type: 'select',
    validations: {
      rules: {
        required: true,
      },
      messages: {
        required: t('global.es_obligatorio'),
      },
    },
    selectLabel: null,
    placeholder: t(
      'landing.components.form_home.tipo_de_mercancia_transportada_placeholder',
    ),
    listenSelect: true,
    listenRemove: true,
    value: null,
    cols: 12,
    customClass: 'inputLanding',
    options: assetOptions.value,
    hidden: false,
  },
  {
    key: 'subAsset',
    title: t('landing.components.form_home.sub_tipo_de_mercancia_transportada'),
    type: 'select',
    selectLabel: null,
    placeholder: t(
      'landing.components.form_home.sub_tipo_de_mercancia_transportada_placeholder',
    ),
    listenSelect: true,
    listenRemove: true,
    value: null,
    cols: 12,
    customClass: 'inputLanding',
    options: [],
    disabled: true,
    hidden: false,
  },
  {
    key: 'product',
    title: t('landing.components.form_home.producto'),
    type: 'select',
    validations: {
      rules: {
        required: false,
      },
      messages: {
        required: t('global.es_obligatorio'),
      },
    },
    selectLabel: null,
    placeholder: t('landing.components.form_home.producto_placeholder'),
    listenSelect: true,
    value: null,
    cols: 12,
    customClass: 'inputLanding',
    options: [],
    hidden: false,
    disabled: true,
    listenRemove: true,
  },
]);

const handleOnSubmit = ({ items, isFormValid }: any) => {
  if (!isFormValid) return;
  if (!toogleIndemnizationLimit.value) {
    if (subDomainInitial.value === 'ARGENTINA') {
      //   isButtonDisabled.value = true;
    }
    return (toogleIndemnizationLimit.value = true);
  }
  const newAudit = {
    email: items.email,
    phone: items.phone,
    asset: items.asset?.nombre,
  };

  createAudits(newAudit);
  findClient(newAudit.email);

  const searchParams = route.query;
  const dataStore = {
    ...newAudit,
    asset: items.asset,
    subAsset: items.subAsset ?? null,
    product: items.product ?? null,
    indemnificationLimit: Number(indemnificationLimit.value.toFixed(0)),
    endPrice: endPrice.value,
    queryParams: searchParams,
  };

  store.setProp({ key: 'data', value: dataStore });

  if (items.typePolicieTransport.nombre === 'Maritimo') {
    return router.push({ name: 'Contratacion Maritima' });
  }
  if (items.typePolicieTransport.nombre === 'Paqueteria') {
    return router.push({ name: 'Contratacion Paqueteria' });
  }

  router.push({ name: 'Contratacion' });
};

const handleSliderChange = (data: number) => {
  // Calculo de precio final para Argentina
  errorResponse.value = null;
  endPrice.value = 0;
  return (indemnificationLimit.value = data);
  //   if (subDomainInitial.value === 'ARGENTINA') {
  //     indemnificationLimit.value = data;

  //     const primaNeta = (data * 0.315) / 100;
  //     const recargosFinacieros = (primaNeta * 6) / 100;

  //     if (!dolarPrice.value) {
  //       return (isButtonDisabled.value = true);
  //     }
  //     if (
  //       data / 1000 <= dolarPrice.value ||
  //       data <= Math.round(dolarPrice.value * 250000) ||
  //       !toogleIndemnizationLimit.value
  //     ) {
  //       isButtonDisabled.value = false;
  //     } else {
  //       isButtonDisabled.value = true;
  //     }

  //     const endPriceValue = primaNeta + recargosFinacieros;
  //     return (endPrice.value = parseFloat(endPriceValue.toFixed(2)));
  //   }

  //   // Calculo de precio final para Chile
  //   if (subDomainInitial.value === 'CHILE') {
  //     indemnificationLimit.value = data;
  //     const value = data * 0.31;

  //     return (endPrice.value = parseFloat(value.toFixed(2)));
  //   }

  //   // Calculo de precio final para Mexico
  //   indemnificationLimit.value = data;

  //   const value = calculatePolicyPrice(data);
  //   endPrice.value = parseFloat(value.toFixed(2));
};

const handleBlur = (data: any) => {
  createAudits({ email: data.value, asset: null, phone: null });
};

const handleValidateSlider = () => {
  if (subDomainInitial.value === 'CHILE' && dolarPrice.value && UFvalue.value) {
    return true;
  } else if (
    subDomainInitial.value === 'SPAIN' &&
    dolarPrice.value &&
    UFvalue.value
  ) {
    return true;
  } else if (subDomainInitial.value === 'ARGENTINA' && dolarPrice.value) {
    return true;
  } else if (subDomainInitial.value === 'MEXICO') {
    return true;
  }

  isButtonDisabled.value = false;
  return false;
};

const handleChangeInputs = async (e: any) => {
  toogleIndemnizationLimit.value = false;
  endPrice.value = 0;
  errorResponse.value = null;

  const key = e.input.key;
  const value = e.value;

  const assetField = fields.value.find((field: any) => field.key === 'asset');
  const subAssetField = fields.value.find((field: any) => field.key === 'subAsset');
  const productField = fields.value.find((field: any) => field.key === 'product');

  // --- Cambio en el campo 'asset' ---
  if (key === 'asset') {
    const subAssets = await getSubAssets(value.id);

    subAssetField.disabled = !subAssets.length;
    productField.disabled = !subAssets.length;
    await refTableForm.value.setValue({ key: 'subAsset', value: null });
    await refTableForm.value.setValue({ key: 'product', value: null });
	// const isRequired = subAssets.length;
    //   productField.required = isRequired;
    //   productField.validations = {
    //     rules: {
    //       required: isRequired,
    //     },
    //   };

    if (subAssetField) {
      subAssetField.options = subAssets;
    }
  }

  // --- Cambio en el campo 'subAsset' ---
  if (key === 'subAsset') {
    toogleIndemnizationLimit.value = false;

    // Obtenemos productos y actualizamos el campo 'product'
    const products = await getProducts(value.id);
    if (productField) {
      productField.options = products;
      productField.disabled = false;

      await refTableForm.value.setValue({ key: 'product', value: null });

      // Reconfiguramos validaciones del campo 'product'
      const isRequired = true;
      productField.required = isRequired;
      productField.validations = {
        rules: {
          required: isRequired,
        },
      };
    }
  }
  if (key === 'typePolicieTransport') {
	const isPaqueteria = value?.nombre === 'Paqueteria';

	if (isPaqueteria) {
		// Limpiar valores relacionados
		await refTableForm.value.setValue({ key: 'asset', value: null });
		await refTableForm.value.setValue({ key: 'subAsset', value: null });
		await refTableForm.value.setValue({ key: 'product', value: null });

		// Desactivar requerimiento del campo 'product'
		productField.required = false;
		productField.validations = {
		rules: {
			required: false,
		},
		};
	}

	// Mostrar u ocultar campos según el tipo de póliza
	assetField.hidden = isPaqueteria;
	subAssetField.hidden = isPaqueteria;
	productField.hidden = isPaqueteria;

	// Ajustar validación del campo 'asset'
	assetField.validations = {
		rules: {
		required: !isPaqueteria,
		},
	};
  }

};

const handleCalculatePrice = async () => {
  const { items } = await refTableForm.value.getValues();

  try {
    const endPriceResponse = await calculatePriceForLanding({
      riskType: items.product ? items.product.riskType : items.asset?.riskType ?? {description: 'PAQUETERIA'},
      indemnificationLimitMax: indemnificationLimit.value,
      assetId: items.asset?.id ?? 999,
    });

    endPrice.value = endPriceResponse.calculation;
  } catch (error: any) {
    errorResponse.value = error.message;
  }
};

const handleRemoveActive = async (e: any) => {
  const key = e.input.key;
  endPrice.value = 0;
  toogleIndemnizationLimit.value = false;
  if (key === 'asset') {
    const subAssetField = fields.value.find(
      (field: any) => field.key === 'subAsset',
    );
    subAssetField.disabled = true;
    await refTableForm.value.setValue({ key: 'subAsset', value: null });
  }
  if (key === 'subAsset') {
    const productField = fields.value.find(
      (field: any) => field.key === 'product',
    );
    productField.disabled = true;
    await refTableForm.value.setValue({ key: 'product', value: null });
	// Reconfiguramos validaciones del campo 'product'
	const isRequired = false;
      productField.required = isRequired;
      productField.validations = {
        rules: {
          required: isRequired,
        },
      };
  }
};
</script>

<template>
  <div class="form">
    <div className="form__container">
      <h3 class="form__title">
        {{ t('landing.components.form_home.cotiza_gratis') }}
      </h3>
      <Form
        ref="refTableForm"
        :inputs="fields"
        @onSubmit="handleOnSubmit"
        @blur="handleBlur"
        @select="handleChangeInputs"
        @remove="handleRemoveActive"
      >
        <template #buttons>
          <div v-if="toogleIndemnizationLimit">
            <h3 class="form__title">
              {{
                t('landing.components.form_home.que_tipo_de_limite_necesita')
              }}
            </h3>
            <div class="form__limitIndemnization">
              <p class="form__subtitle">
                {{
                  t(
                    'landing.components.form_home.seleccione_el_limite_de_indemnizacion',
                  )
                }}
              </p>
              <div class="form__slider" v-if="handleValidateSlider()">
                <Slider
                  @value="handleSliderChange"
                  :subDomainInitial="subDomainInitial"
                  :dolarPrice="dolarPrice ?? undefined"
                  :UFvalue="UFvalue ?? undefined"
                />
              </div>
              <div class="form__endPrice-container">
                <div
                  class="form__endPrice-container d-flex flex-column justify-content-center align-items-center"
                >
                 
                  <p class="form__endPrice" v-if="endPrice !== 0"></p>
                  <p class="form__endPrice">
                    <span>{{
                      subDomainInitial === 'CHILE'
                        ? `${t('landing.components.form_home.precio_fina_uf')}: `
                        : `${t('landing.components.form_home.precio_final')}: `
                    }}</span>
                    <span class="form__endPrice-span"
                      >{{ getTypeMoney(subDomainInitial) }} {{ endPrice }}</span
                    >
                    +
                    {{
                      subDomainInitial === 'CHILE'
                        ? t('landing.components.form_home.iva')
                        : t('landing.components.form_home.impuestos')
                    }}
                  </p>
                  <p v-if="errorResponse" class="text-danger">
                    {{ errorResponse }}
                  </p>
                </div>
              </div>
              <span class="form__span" v-if="subDomainInitial === 'MEXICO'">{{
                t('landing.components.form_home.valores_mxn')
              }}</span>
              <span class="form__span" v-if="subDomainInitial === 'ARGENTINA'">{{
                t('landing.components.form_home.valores_ars')
              }}</span>
              <span class="form__span" v-if="subDomainInitial === 'ARGENTINA'">
                {{
                  t('landing.components.form_home.precio_aproximado_ars')
                }}</span
              >
              <span class="form__span" v-if="subDomainInitial === 'CHILE'">{{
                t('landing.components.form_home.valores_uf')
              }}</span>
            </div>
          </div>
          <div class="d-flex">
			<button
				v-if="endPrice === 0 && toogleIndemnizationLimit"
				class="p-4 w-100 my-2 px-2 background-green color-white border-0 rounded-4"
				style="font-weight: bold; font-size: 2rem"
				@click="handleCalculatePrice"
				type="button"
			>
				{{ t('landing.components.form_home.calcular_precio') }}
			</button>
            <button
			  v-if="endPrice !== 0 || !toogleIndemnizationLimit"
              class="p-4 w-100 my-2 px-2 background-green color-white border-0 rounded-4"
              style="font-weight: bold; font-size: 2rem"
              :disabled="
                isButtonDisabled || (toogleIndemnizationLimit && endPrice === 0)
              "
              type="submit"
            >
              {{ t('landing.components.form_home.quiero_el_seguro') }}
            </button>
          </div>
        </template>
      </Form>
    </div>
  </div>
</template>
